(function ($) {
    
    function initPostSlider() {
        $( '.js-post-slider' ).not('.slick-initialized').each( function() {
            $( this ).slick( {
                infinite: true,
                slidesToShow: 3,
                arrows: true,
                slidesToScroll: 1,
//                appendArrows: $(this).parents('.post-slider').find('.post-arrows-inner'),
                prevArrow: $(this).parents('.post-slider').find('.post-arrows-prev'),
                nextArrow: $(this).parents('.post-slider').find('.post-arrows-next'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }
    /* Document Ready */
	$(document).ready(function() {
        initPostSlider();
	});
    
    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=post-slider', initPostSlider);
    }

})(jQuery);